var $446b9fab6a38255c$exports = {};
$446b9fab6a38255c$exports = {
    "loading": `Ladataan\u{2026}`,
    "loadingMore": `Ladataan lis\xe4\xe4\u{2026}`
};


export {$446b9fab6a38255c$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
